"use client";
import React from "react";
import { SDialogFC, SDialogProps } from "@/Master/SDialogFC/SDialogFC";
import { Button, FontIcon } from "@/app/_components";
import {SDialogManagerFC} from "@/Master/SDialogFC/SDialogManagerFC";
import styles from "./newcomerGiftPack.module.css";

interface NewcomerGiftPackDialogProps extends SDialogProps {}

export const NewcomerGiftPackDialogFC: React.FC<NewcomerGiftPackDialogProps> = (props) => {
    const { fcKey, isOpen } = props;

    if (!isOpen) return null;

    const onClose = () => {
        SDialogManagerFC.closeDialog(fcKey);
    };

    return (
        <SDialogFC
            fcKey={fcKey}
            isOpen={isOpen}
            mode="Full"
            title={<span>{'\n\n\n'}</span>}
        >
            <section className={`${styles.layer}`}></section>
            <section className={`${styles.wrapper} h-v-center`}>
                <section className={styles.content}>
                    <div className={styles.icon_close} onClick={onClose}>
                        <FontIcon icon="s-close" style={{ color: "#DC5AEB" }} />
                    </div>
                    <h4>WELCOME</h4>
                    <h1>Go Go Gold</h1>
                    <div className={styles.main}>
                        <img className={styles.main_icon} src="/img/ico_gift_newcomer.webp" alt="" />
                        <div className={styles.text_claim}>Claim your</div>
                        <div>
                            <img className={styles.icon_gold} src="/img/ico_gc.png" alt="" />
                            <span className={styles.text_num}>100K</span>
                            <span className={styles.text_plus}>+</span>
                            <img className={styles.icon_gold} src="/img/ico_sc.png" alt="" />
                            <span className={styles.text_num}>2</span>
                        </div>
                    </div>
                    <Button
                        color="#33D24A"
                        style={{
                            color: "#fff",
                            width: "5rem",
                            height: "1.1rem",
                            fontSize: ".6rem",
                            fontWeight: 900,
                        }}
                        onClick={onClose}
                    >
                        Claim
                    </Button>
                </section>
            </section>
        </SDialogFC>
    );
};
